// Lib imports
import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT, 
    timeout: 10000,

});

instance.cancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

export default instance;
